import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'ppl-view-global-ledger',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './view-global-ledger.component.html',
  styleUrl: './view-global-ledger.component.css'
})
export class ViewGlobalLedgerComponent {

}
